import styled, { css } from 'styled-components'

import Modal from '../../../common/modal'
import { WidgetCard } from '../widget-card'

export const UserMenuWidget = styled(WidgetCard)(
    ({ theme }) => css`
        right: 0;
        top: 100%;
        margin-top: ${theme.spacing.xSmall};
    `,
)

export const UserMenuModal = styled(Modal)(
    ({ theme }) => css`
        & .Overlay {
            align-items: flex-end;
        }

        & .ReactModal__Overlay {
            transition: background-color 200ms ease-out 350ms;
        }

        & .Modal {
            width: ${theme.layout.fill};
            padding-bottom: ${theme.spacing.medium};
            border-radius: ${theme.typography.border.radius.xLarge} ${theme.typography.border.radius.xLarge} 0 0;
        }

        /* For slide-in and slide-out transition. More examples given in react-modal documentation. */

        & .ReactModal__Content {
            transform: translateY(100%);
            transition: transform 350ms ease-in;
        }

        & .ReactModal__Content--after-open {
            transform: translateY(0);
        }

        & .ReactModal__Content--before-close {
            transform: translateY(100%);
        }
    `,
)
